// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    // Store Custom Code
    color: "#115ffb",
};

export default focus;
